import { render, staticRenderFns } from "./IGCommentManagement.vue?vue&type=template&id=a9531ad0&scoped=true"
import script from "./IGCommentManagement.vue?vue&type=script&lang=js"
export * from "./IGCommentManagement.vue?vue&type=script&lang=js"
import style0 from "./IGCommentManagement.vue?vue&type=style&index=0&id=a9531ad0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9531ad0",
  null
  
)

export default component.exports